import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function ClosingSection() {
  const [selectedOption, setSelectedOption] = useState<'basic' | 'pro'>('pro');
  const checkoutUrls = {
    basic: 'https://checkout.infinita-mente.online/cart/42618198491234:1',
    pro: 'https://checkout.infinita-mente.online/cart/42652373450850:1'
  };
  return <section className="w-full py-24 bg-transparent px-4 font-sans relative overflow-hidden" data-id="element-65">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[500px] bg-gradPurple/10 blur-[150px] rounded-full pointer-events-none" data-id="element-66" />

      <div className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="w-full flex flex-col items-center" data-id="element-68">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-69">
            ¿Vas a seguir improvisando tu cursada?
          </h2>

          <p className="text-lg md:text-xl text-textMuted max-w-2xl mb-12 font-medium leading-relaxed" data-id="element-70">
            Más de 500 estudiantes ya organizaron su cuatrimestre. El precio de
            lanzamiento no dura para siempre.
          </p>

          {/* Simplified Pricing Container */}
          <div className="w-full max-w-xl bg-cardBg/90 backdrop-blur-md rounded-[2rem] p-6 md:p-8 border-2 border-gradPurple/30 shadow-[0_0_50px_rgba(138,43,226,0.2)] flex flex-col relative overflow-visible text-left" data-id="element-71">
            {/* Option 1: Basic */}
            <div onClick={() => setSelectedOption('basic')} className={`relative w-full rounded-2xl p-4 md:p-5 cursor-pointer transition-all duration-300 flex items-center gap-4 ${selectedOption === 'basic' ? 'border-2 border-gradPurple bg-gradPurple/20 shadow-[0_0_20px_rgba(138,43,226,0.3)]' : 'border-2 border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-72">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOption === 'basic' ? 'border-gradPurple bg-gradPurple' : 'border-white/40 bg-transparent'}`} data-id="element-73">
                {selectedOption === 'basic' && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-74" />}
              </div>
              <div className="flex-1 flex justify-between items-center gap-2" data-id="element-75">
                <div data-id="element-76">
                  <h3 className="text-base md:text-lg font-black text-white leading-tight" data-id="element-77">
                    MEGA PACK UNIVERSITARIO
                  </h3>
                  <p className="text-white/70 text-xs md:text-sm font-medium" data-id="element-78">
                    5 Tomos + 3 bonos gratis
                  </p>
                </div>
                <div className="text-right" data-id="element-79">
                  <div className="text-white/50 line-through text-[10px] md:text-xs font-bold" data-id="element-80">
                    $39.998
                  </div>
                  <div className="text-lg md:text-2xl font-black text-white leading-tight" data-id="element-81">
                    $19.999
                  </div>
                </div>
              </div>
            </div>

            {/* Spacer */}
            <div className="my-3" data-id="element-82" />

            {/* Badges for Pro */}
            <div className="flex justify-center gap-2 md:gap-3 mb-3 relative z-10" data-id="element-83">
              <div className="text-[10px] md:text-xs font-black px-3 md:px-4 py-1.5 rounded-full flex items-center gap-1 uppercase tracking-widest bg-gradient-to-r from-gradOrange to-gradPink text-white shadow-[0_0_15px_rgba(255,107,0,0.4)]" data-id="element-84">
                ⭐ MÁS ELEGIDO
              </div>
              <div className="text-[10px] md:text-xs font-bold px-3 md:px-4 py-1.5 rounded-full uppercase tracking-widest backdrop-blur-sm bg-white/15 border border-white/30 text-white" data-id="element-85">
                AHORRÁS $22.000
              </div>
            </div>

            {/* Option 2: Pro */}
            <div onClick={() => setSelectedOption('pro')} className={`relative w-full rounded-2xl p-4 md:p-5 cursor-pointer transition-all duration-300 flex items-center gap-4 ${selectedOption === 'pro' ? 'border-2 border-gradPurple bg-gradPurple/20 shadow-[0_0_20px_rgba(138,43,226,0.3)]' : 'border-2 border-white/10 bg-white/5 hover:bg-white/10'}`} data-id="element-86">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedOption === 'pro' ? 'border-gradPurple bg-gradPurple' : 'border-white/40 bg-transparent'}`} data-id="element-87">
                {selectedOption === 'pro' && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-88" />}
              </div>
              <div className="flex-1 flex justify-between items-center gap-2" data-id="element-89">
                <div data-id="element-90">
                  <h3 className="text-base md:text-lg font-black text-white leading-tight" data-id="element-91">
                    MEGAPACK PRO
                  </h3>
                  <p className="text-white/70 text-xs md:text-sm font-medium leading-snug mt-0.5" data-id="element-92">
                    5 Tomos + 3 bonos + Protocolo Elite
                  </p>
                </div>
                <div className="text-right" data-id="element-93">
                  <div className="text-white/50 line-through text-[10px] md:text-xs font-bold" data-id="element-94">
                    $49.998
                  </div>
                  <div className="text-lg md:text-2xl font-black text-white leading-tight" data-id="element-95">
                    $27.999
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <a href={checkoutUrls[selectedOption]} target="_blank" rel="noopener noreferrer" className="w-full bg-gradient-to-r from-[#10B981] to-[#047857] hover:from-[#059669] hover:to-[#065f46] text-white font-black text-lg md:text-xl py-4 rounded-full mt-8 shadow-[0_0_15px_rgba(16,185,129,0.3)] transition-all flex items-center justify-center gap-2 hover:scale-105 no-underline" data-id="element-96">
              SÍ, QUIERO MI PACK HOY →
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs md:text-sm font-medium text-textMuted mt-10" data-id="element-97">
            <span className="flex items-center gap-2" data-id="element-98">
              <span className="text-white/50" data-id="element-99">🔒</span> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-100">
              <span className="text-white/50" data-id="element-101">⚡</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-2" data-id="element-102">
              <span className="text-white/50" data-id="element-103">🛡️</span> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-104">
              <span className="text-white/50" data-id="element-105">💳</span> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}